export const RYAN_STORY = {
  heading: "Why I'm building this.",
  photo: "/ryan.jpg",
  photoAlt: "Ryan, founder of The Keep",
  paragraphs: [
    "My first company failed. It wasn't a bad idea. I was passionate about it and put in endless late nights, but the tools and support I needed to move it forward weren't there. When it fell apart, I blamed myself. I sank into depression and used drugs to escape, and I spent almost every day stuck in my own head. I came close to ending my life twice. I tried therapy, but it wasn't what helped me.",
    "What did was a person who showed up at the hardest time of my life and took a chance on me. He listened, and he told me the honest, unfiltered truth I needed to hear. I believe God had a plan in that. With him and the other people who stood by me, I found my way back.",
    "I always liked my quiet, solitary space, but it was full of doubt and anger. Asking for help was the hardest thing in the world for me. I thought I had it all figured out, and I know a lot of founders feel the same. But being around people who truly showed up changed me, and it pushed me to turn my life around. I wouldn't be here without the people who refused to give up on me.",
    "We each get one life, with goals and dreams we want to reach. I want to do for the first founders who join The Keep what those people did for me, and build this space with them.",
  ],
  signature: "— Ryan",
};

export const STATS = [
  {
    value: "54%",
    text: "of founders reported burnout in the previous 12 months.",
    source: "Sifted founder survey, 2025",
    url: "https://sifted.eu/articles/founders-mental-health-2025",
  },
  {
    value: "87.7%",
    text: "of entrepreneurs struggled with at least one mental-health issue, in one survey of 227 founders across 46 countries.",
    source: "Founder Reports, 2025",
    url: "https://founderreports.com/entrepreneur-mental-health-statistics/",
  },
  {
    value: "~50%",
    text: "of CEOs report feeling lonely in the role.",
    source: "Harvard Business Review research",
    url: "https://hbr.org/2012/02/its-time-to-acknowledge-ceo-lo",
  },
];

export const FAMILIAR_LINES = [
  "It's 1am, you're deciding something big, and there's nobody to ask if you're being smart or scared.",
  "You've got a dozen tabs open about things you're supposed to already understand.",
  "You tell everyone it's going great.",
  "Everyone says \u201Cbuild in public.\u201D Nobody asks how you're actually doing.",
  "You're not failing. You're doing five jobs with nobody next to you.",
];

export const FIRST_HUNDRED_POINTS = [
  {
    title: "We sit down together first.",
    body: "Before anything is built, we talk about what real support should look like.",
  },
  {
    title: "Matched by a person.",
    body: "You tell us what you're good at and what's hardest. I match you by hand.",
  },
  {
    title: "Tools and resources picked with you.",
    body: "Nothing sponsored, nothing padded.",
  },
  {
    title: "Small on purpose.",
    body: "Not a course. Not a Discord of thousands.",
  },
];
